export default {
	authenticated: state => state.user != null && state.token != null,
};
